export class PageParams {
    constructor(
      public start: number,
      public pageSize: number) {
    }
  }
  